import { createAction } from 'redux-actions';

export const setSelectedElementDetails = createAction(
  'SET_SELECTED_ELEMENT_DETAILS_ACTION',
);

export const clearReportPreviewPageData = createAction(
  'CLEAR_REPORT_PREVIEW_PAGE_DATA_ACTION',
);

export const clearSelectedElementsSectionId = createAction(
  'CLEAR_SELECTED_ELEMENTS_SECTION_ID_ACTION',
);

export const setPreviewPageDisplayOptionAction = createAction(
  'SET_PREVIEW_PAGE_DISPLAY_OPTION',
);

export const setReOrderedColumnOptions = createAction(
  'SET_REORDERED_COLUMN_OPTIONS',
);
export const setReportPreviewPageDisplayOptions = createAction(
  'SET_DISPLAY_OPTION_VALUES',
);

export const resetReOrderedColumnOptions = createAction(
  'RESET_REORDERED_COLUMN_OPTIONS',
);
